<template>
  <ReCruiseModal :showModal="showModal" @update:showModal="updateShowModal">
    <template #header="{ closeModal }">
      <div class="modal-header">
        <div></div>

        <div class="modal-title">{{ $t('panstarPay.panstarRegistered') }}</div>

        <button class="close-button" @click="closeModal">
          <img src="@/assets/images/icon/close_icon.svg" alt="icon" />
        </button>
      </div>
    </template>

    <template #content>
      <div class="panstar-pay-complete-container">
        <div class="complete-wrapper">
          <div class="img-wrapper">
            <img src="@/assets/images/panstarPay/miracle_logo.png" />
          </div>

          <div class="complete-text-wrapper">
            <div class="text-main">{{ $t('panstarPay.cardAdded') }}</div>

            <div class="text-sub">
              {{ $t('panstarPay.readyToGo') }} <br />
              {{ $t('panstarPay.enjoyWithPanstar') }}
            </div>
          </div>
        </div>

        <div class="bottom-btn-wrapper">
          <ReCruiseButton class="bottom-btn" @click="updateShowModal(false)">
            {{ $t('actions.confirm') }}
          </ReCruiseButton>
          <!-- <ReCruiseButton class="bottom-btn" theme="outline" @click="goToExplain">
            {{ $t('panstarPay.howToUse') }}
          </ReCruiseButton> -->
        </div>
      </div>
    </template>
  </ReCruiseModal>
</template>

<script>
import ReCruiseModal from '@/components/renewal/modal/ReCruiseModal.vue';
import ReCruiseButton from '@/components/renewal/button/ReCruiseButton.vue';

export default {
  name: 'PanstarPayRegisterComplete',
  components: { ReCruiseModal, ReCruiseButton },
  props: {
    showModal: { type: Boolean, required: true },
  },
  data() {
    return {
      step: 'complete',
    };
  },
  methods: {
    updateShowModal(value) {
      this.$emit('update:showModal', value);
    },
    goToExplain() {
      this.updateShowModal(false);
      // TODO: 페이지 이동
    },
  },
};
</script>

<style scoped>
.modal-header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.panstar-pay-complete-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.complete-wrapper {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
}

.img-wrapper {
  width: fit-content;
  height: fit-content;
}

.complete-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.text-main {
  color: var(--Grey-grey-900, #333);
  font-family: 'Pretendard';
  font-size: 24px;
  font-weight: 600;
}

.text-sub {
  color: var(--Grey-grey-900, #333);
  text-align: center;
  font-family: 'Pretendard';
  font-size: 18px;
  font-weight: 400;
}

.bottom-btn-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bottom-btn {
  width: 100%;
  height: 44px;
}
</style>
